// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Preloader_loaderContainer__THtL-","loader":"Preloader_loader__JKgKX","spinanimation":"Preloader_spinanimation__uZ02f"};